import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as filterConvert from './panels/FilterConvert';
import _ from 'lodash';

const FilterImage = props => {
  const filter = filterConvert.filterSet(props.filter);
  const svgWidth = _.get(props, 'style.width', '100%');
  const svgHeight = _.get(props, 'style.height', '100%');
  const filterId = props.id.replace(/[^A-Z0-9]/gi, '');
  const vignetteContainer = useRef(null);

  useEffect(() => {
    const mainEntityTarget = document.querySelector(`[data-target="${props.entityId}"]`);
    const imageHolder = document.getElementById(`E${props.entityId}`);
    if (!imageHolder) return undefined;

    const holderStyle = window.getComputedStyle(imageHolder);
    const vignetteSetPosition = () => {
      // eslint-disable-next-line no-undef
      const holderStyleMatrix = new WebKitCSSMatrix(holderStyle.webkitTransform);
      if (vignetteContainer.current) {
        if (holderStyleMatrix) {
          vignetteContainer.current.style.transform = `translate(${-holderStyleMatrix.m41}px, ${-holderStyleMatrix.m42}px)`;
        }
        vignetteContainer.current.style.width = _.get(mainEntityTarget, 'style.width', '100%');
        vignetteContainer.current.style.height = _.get(mainEntityTarget, 'style.height', '100%');
      }
    };

    vignetteSetPosition();
    const observer = new MutationObserver(() => {
      vignetteSetPosition();
    });
    if (mainEntityTarget) {
      observer.observe(mainEntityTarget, {
        attributes: true,
        attributeFilter: ['style'],
      });
    }

    return () => observer.disconnect();
  }, [props.entityId]);

  return (
    <>
      {filter.vignette.Dec !== 100 && (
        <div
          ref={vignetteContainer}
          className="vignetteEft"
          style={{
            background: `rgba(${filter.vignette.color}, 0) radial-gradient(circle farthest-side, rgba(${filter.vignette.color}, 0) 70%, rgba(${filter.vignette.color}, ${filter.vignette.opacity}) 130%) repeat scroll 0% 0%`,
          }}
        ></div>
      )}
      <svg
        type={props.type}
        width={svgWidth}
        height={svgHeight}
        // viewBox={`1 1 ${props.style.width} ${props.style.height}`}
        onLoad={props.onLoad}
      >
        <filter id={`filter_${filterId}_${props.filter}`} colorInterpolationFilters="sRGB">
          <feBlend></feBlend>
          {filter.brightness.Dec !== 100 && (
            <feComponentTransfer>
              <feFuncR type="linear" slope="1" intercept={filter.brightness.intercept}></feFuncR>
              <feFuncG type="linear" slope="1" intercept={filter.brightness.intercept}></feFuncG>
              <feFuncB type="linear" slope="1" intercept={filter.brightness.intercept}></feFuncB>
            </feComponentTransfer>
          )}
          {filter.contrast.Dec !== 100 && (
            <feComponentTransfer>
              <feFuncR
                type="linear"
                slope={filter.contrast.slope}
                intercept={filter.contrast.intercept}
              ></feFuncR>
              <feFuncG
                type="linear"
                slope={filter.contrast.slope}
                intercept={filter.contrast.intercept}
              ></feFuncG>
              <feFuncB
                type="linear"
                slope={filter.contrast.slope}
                intercept={filter.contrast.intercept}
              ></feFuncB>
            </feComponentTransfer>
          )}
          {filter.saturation.Dec !== 100 && (
            <feColorMatrix
              type="matrix"
              values={`${filter.saturation.r1} ${filter.saturation.r2} ${filter.saturation.r3} 0 0 
                   ${filter.saturation.g1} ${filter.saturation.g2} ${filter.saturation.g3} 0 0 
                   ${filter.saturation.b1} ${filter.saturation.b2} ${filter.saturation.b3} 0 0 
                  0 0 0 1 0`}
            ></feColorMatrix>
          )}
          {filter.tint.Dec !== 100 && (
            <feComponentTransfer>
              <feFuncR type="linear" slope="0.9" intercept={filter.tint.R}></feFuncR>
              <feFuncG type="linear" slope="0.9" intercept={filter.tint.G}></feFuncG>
              <feFuncB type="linear" slope="0.9" intercept={filter.tint.B}></feFuncB>
            </feComponentTransfer>
          )}
          {filter.blur.Dec > 100 && (
            <>
              <feGaussianBlur stdDeviation={filter.blur.gaussianBlur}></feGaussianBlur>
              <feComponentTransfer>
                <feFuncA type="table" tableValues="0 1 1 1"></feFuncA>
              </feComponentTransfer>
            </>
          )}
          {filter.blur.Dec < 100 && (
            <>
              <feBlend result="preblur"></feBlend>
              <feGaussianBlur stdDeviation="2.4"></feGaussianBlur>
              <feComponentTransfer>
                <feFuncA type="table" tableValues="0 1 1 1"></feFuncA>
              </feComponentTransfer>
              <feComposite
                operator="arithmetic"
                k1="0"
                k2={filter.blur.k2}
                k3={filter.blur.k3}
                k4="0"
                in2="preblur"
              ></feComposite>
            </>
          )}

          {filter.xProcess.Dec !== 100 && (
            <feComponentTransfer>
              <feFuncR type="table" tableValues={filter.xProcess.R}></feFuncR>
              <feFuncG type="table" tableValues={filter.xProcess.G}></feFuncG>
              <feFuncB type="table" tableValues={filter.xProcess.B}></feFuncB>
            </feComponentTransfer>
          )}
        </filter>
        <image
          xlinkHref={props.src}
          x="0"
          y="0"
          width="100%"
          height="100%"
          filter={`url(#filter_${filterId}_${props.filter})`}
          preserveAspectRatio="xMidYMid slice"
        ></image>
      </svg>
    </>
  );
};

FilterImage.propTypes = {
  filter: PropTypes.any,
  type: PropTypes.string,
  style: PropTypes.any,
  id: PropTypes.string,
  src: PropTypes.string,
  onLoad: PropTypes.func,
};

export default FilterImage;
